"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../../constants/PropTypes"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _misc = require("HubStyleTokens/misc");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _NestedNavItem = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/NestedNavItem"));

var _NestedNav = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/NestedNav"));

var _categoryFeatures = require("ecosystem-marketplace-core/constants/groupTags/categoryFeatures");

var GROUPED_CATEGORIES = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/superCategoryGroups"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _superCategoryOrder = _interopRequireDefault(require("../../../../constants/superCategoryOrder"));

var FilterKey = _interopRequireWildcard(require("../../../../constants/search/FilterKey"));

var _groupTags = require("../../../../utils/groupTags");

var _history = require("../../../../utils/history");

var _usePrevious = require("../../../../utils/hooks/usePrevious");

var _urls = require("../../../../utils/urls");

var _NestedNavCheckboxItem = _interopRequireDefault(require("../inputs/NestedNavCheckboxItem"));

var _UnstyledNestedNavItem = _interopRequireDefault(require("../inputs/UnstyledNestedNavItem"));

var EMPTY_SET = _immutable.default.Set();

var ALL = 'all';
var superCategoryOrder = [ALL].concat((0, _toConsumableArray2.default)(_superCategoryOrder.default));

var getOpenIcon = function getOpenIcon(open) {
  return open ? 'up' : 'down';
};

var FeaturesToggleGroup = function FeaturesToggleGroup(_ref) {
  var category = _ref.category,
      onChange = _ref.onChange,
      selectedFeatures = _ref.selectedFeatures;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var renderedFeatures = (0, _react.useMemo)(function () {
    return _immutable.default.Set(Object.values(_categoryFeatures.BY_CATEGORY[category])).map(function (feature) {
      return [feature, (0, _i18n.getCategoryFeatureI18nKey)(category, feature)];
    }).sortBy(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          featureI18nKey = _ref3[1];

      return (0, _unescapedText.default)(featureI18nKey);
    }).map(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          feature = _ref5[0],
          featureI18nKey = _ref5[1];

      return _react.default.createElement(_NestedNavCheckboxItem.default, {
        key: feature,
        checkboxProps: {
          checked: selectedFeatures.includes(feature),
          onChange: onChange,
          value: feature
        },
        title: _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
          message: featureI18nKey
        }))
      });
    }).slice(0, expanded ? undefined : 5);
  }, [category, expanded, onChange, selectedFeatures]);
  return _react.default.createElement(_react.Fragment, null, renderedFeatures, !expanded && _react.default.createElement(_UnstyledNestedNavItem.default, {
    onClick: function onClick() {
      setExpanded(true);
    },
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.storefront.filters.categoryFeatures.toggleGroup.expandButtonText"
    }),
    use: "link"
  }));
};

var CategoryNavItem = function CategoryNavItem(_ref6) {
  var category = _ref6.category,
      filters = _ref6.filters,
      isActive = _ref6.isActive,
      onCategoryChange = _ref6.onCategoryChange,
      onFeatureChange = _ref6.onFeatureChange,
      selectedFeatures = _ref6.selectedFeatures,
      superCategory = _ref6.superCategory,
      trackFilterNavItemClick = _ref6.trackFilterNavItemClick,
      rest = (0, _objectWithoutProperties2.default)(_ref6, ["category", "filters", "isActive", "onCategoryChange", "onFeatureChange", "selectedFeatures", "superCategory", "trackFilterNavItemClick"]);
  var prevIsActive = (0, _usePrevious.usePrevious)(isActive);

  var _useState3 = (0, _react.useState)(isActive),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      duration = _useState6[0],
      setDuration = _useState6[1];

  var categoryFilters = (0, _react.useMemo)(function () {
    return filters.withMutations(function (mutableFilters) {
      mutableFilters.delete(FilterKey.COLLECTION).delete(FilterKey.SEARCH).set(FilterKey.SUPER_CATEGORY, superCategory).set(FilterKey.CATEGORY, category).set(FilterKey.CATEGORY_FEATURES, isActive ? (0, _groupTags.filterFeaturesByCategory)(selectedFeatures, category) : EMPTY_SET);
    });
  }, [category, filters, isActive, selectedFeatures, superCategory]);
  var handleFeatureChange = (0, _react.useCallback)(function (evt) {
    if (isActive) {
      onFeatureChange(evt);
    } else {
      var value = evt.target.value;
      (0, _history.push)(categoryFilters.set(FilterKey.CATEGORY_FEATURES, EMPTY_SET.add(value)).toLocation());
    }
  }, [categoryFilters, isActive, onFeatureChange]);
  (0, _react.useLayoutEffect)(function () {
    if (isActive !== prevIsActive) {
      setOpen(isActive);
      setDuration(0);
    }
  }, [isActive, prevIsActive]);
  return _react.default.createElement(_NestedNavItem.default, (0, _extends2.default)({}, rest, {
    active: isActive,
    duration: duration,
    href: (0, _history.getFullHref)((0, _urls.getCategoryFilterUrl)(category, superCategory)),
    iconRight: function iconRight(_ref7) {
      var iconClassName = _ref7.className;
      return _react.default.createElement(_UIIcon.default, {
        className: iconClassName,
        name: getOpenIcon(open),
        onClick: function onClick(evt) {
          evt.stopPropagation();
          evt.preventDefault();
          setOpen(!open);
        },
        size: "xxs"
      });
    },
    onClick: function onClick(evt) {
      evt.preventDefault();
      onCategoryChange(superCategory, category);
      trackFilterNavItemClick(FilterKey.CATEGORY, category);
    },
    onOpenChange: function onOpenChange(_ref8) {
      var value = _ref8.target.value;
      setOpen(value);
      setDuration(undefined);
    },
    open: open,
    style: {
      fontSize: 14
    },
    title: (0, _unescapedText.default)((0, _i18n.getCategoryI18nKey)(category)),
    _rootRenderer: function _rootRenderer(children) {
      return _react.default.createElement(_NestedNav.default, {
        className: "m-y-0 p-left-4"
      }, children);
    }
  }), _react.default.createElement(FeaturesToggleGroup, {
    category: category,
    onChange: handleFeatureChange,
    selectedFeatures: selectedFeatures
  }));
};

var SuperCategoryNavItem = function SuperCategoryNavItem(_ref9) {
  var activeCategory = _ref9.activeCategory,
      activeSuperCategory = _ref9.activeSuperCategory,
      filters = _ref9.filters,
      isAllCategories = _ref9.isAllCategories,
      onCategoryChange = _ref9.onCategoryChange,
      onFeatureChange = _ref9.onFeatureChange,
      selectedFeatures = _ref9.selectedFeatures,
      superCategory = _ref9.superCategory,
      trackFilterNavItemClick = _ref9.trackFilterNavItemClick,
      rest = (0, _objectWithoutProperties2.default)(_ref9, ["activeCategory", "activeSuperCategory", "filters", "isAllCategories", "onCategoryChange", "onFeatureChange", "selectedFeatures", "superCategory", "trackFilterNavItemClick"]);
  var isActive = superCategory === ALL ? isAllCategories : superCategory === activeSuperCategory;
  var prevIsActive = (0, _usePrevious.usePrevious)(isActive);

  var _useState7 = (0, _react.useState)(isActive),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      open = _useState8[0],
      setOpen = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      duration = _useState10[0],
      setDuration = _useState10[1];

  var superCategoryI18nKey = superCategory === ALL ? 'appMarketplace.storefront.filters.category.items.all.titleText' : (0, _i18n.getSuperCategoryI18nKey)(superCategory);
  var children = (0, _react.useMemo)(function () {
    if (superCategory === ALL) {
      return null;
    }

    return _immutable.default.List(Object.values(GROUPED_CATEGORIES[superCategory])).map(function (category) {
      return [category, (0, _i18n.getCategoryI18nKey)(category)];
    }).sortBy(function (_ref10) {
      var _ref11 = (0, _slicedToArray2.default)(_ref10, 2),
          categoryI18nKey = _ref11[1];

      return (0, _unescapedText.default)(categoryI18nKey);
    }).map(function (_ref12) {
      var _ref13 = (0, _slicedToArray2.default)(_ref12, 1),
          category = _ref13[0];

      return _react.default.createElement(CategoryNavItem, {
        key: category,
        filters: filters,
        isActive: isActive && category === activeCategory,
        category: category,
        onCategoryChange: onCategoryChange,
        onFeatureChange: onFeatureChange,
        selectedFeatures: selectedFeatures,
        superCategory: superCategory,
        trackFilterNavItemClick: trackFilterNavItemClick
      });
    });
  }, [activeCategory, filters, isActive, onCategoryChange, onFeatureChange, selectedFeatures, superCategory, trackFilterNavItemClick]);
  (0, _react.useLayoutEffect)(function () {
    if (isActive !== prevIsActive) {
      setOpen(isActive);
      setDuration(0);
    }
  }, [isActive, prevIsActive]);
  return _react.default.createElement(_NestedNavItem.default, (0, _extends2.default)({}, rest, {
    active: isActive && !activeCategory,
    duration: duration,
    href: (0, _history.getFullHref)(superCategory === ALL ? (0, _urls.getAllCategoriesUrl)() : (0, _urls.getSuperCategoryFilterUrl)(superCategory)),
    iconRight: function iconRight(_ref14) {
      var iconClassName = _ref14.className;

      if (children == null) {
        return null;
      }

      return _react.default.createElement(_UIIcon.default, {
        className: iconClassName,
        name: getOpenIcon(open),
        onClick: function onClick(evt) {
          evt.stopPropagation();
          evt.preventDefault();
          setOpen(!open);
        },
        size: "xxs"
      });
    },
    onClick: function onClick(evt) {
      evt.preventDefault();
      onCategoryChange(superCategory !== ALL ? superCategory : undefined);
      trackFilterNavItemClick(FilterKey.SUPER_CATEGORY, superCategory === ALL ? 'all categories' : superCategory);
    },
    onOpenChange: function onOpenChange(_ref15) {
      var value = _ref15.target.value;
      setOpen(value);
      setDuration(undefined);
    },
    open: open,
    style: {
      fontWeight: isActive ? _misc.WEB_FONT_DEMI_BOLD_WEIGHT : _misc.WEB_FONT_REGULAR_WEIGHT
    },
    title: (0, _unescapedText.default)(superCategoryI18nKey)
  }), children);
};

var CategoryFilterNav = function CategoryFilterNav(_ref16) {
  var activeCategory = _ref16.activeCategory,
      activeSuperCategory = _ref16.activeSuperCategory,
      filters = _ref16.filters,
      isAllCategories = _ref16.isAllCategories,
      onCategoryChange = _ref16.onCategoryChange,
      onFeaturesChange = _ref16.onFeaturesChange,
      selectedFeatures = _ref16.selectedFeatures,
      trackFilterNavItemClick = _ref16.trackFilterNavItemClick;
  var handleFeatureChange = (0, _react.useCallback)(function (_ref17) {
    var _ref17$target = _ref17.target,
        checked = _ref17$target.checked,
        value = _ref17$target.value;
    onFeaturesChange(checked ? selectedFeatures.union([value]) : selectedFeatures.subtract([value]));
  }, [onFeaturesChange, selectedFeatures]);
  return _react.default.createElement(_NestedNav.default, {
    className: "m-bottom-0"
  }, superCategoryOrder.map(function (superCategory) {
    return _react.default.createElement(SuperCategoryNavItem, {
      key: superCategory,
      activeCategory: activeCategory,
      activeSuperCategory: activeSuperCategory,
      filters: filters,
      isAllCategories: isAllCategories,
      onCategoryChange: onCategoryChange,
      onFeatureChange: handleFeatureChange,
      selectedFeatures: selectedFeatures,
      superCategory: superCategory,
      trackFilterNavItemClick: trackFilterNavItemClick
    });
  }));
};

CategoryFilterNav.propTypes = {
  activeCategory: CustomPropTypes.category,
  activeSuperCategory: CustomPropTypes.superCategory,
  filters: CustomPropTypes.storefrontFilters.isRequired,
  isAllCategories: _propTypes.default.bool.isRequired,
  onCategoryChange: _propTypes.default.func.isRequired,
  onFeaturesChange: _propTypes.default.func.isRequired,
  selectedFeatures: _reactImmutableProptypes.default.iterableOf(CustomPropTypes.categoryFeature).isRequired,
  trackFilterNavItemClick: _propTypes.default.func.isRequired
};
var _default = CategoryFilterNav;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/nav/CategoryFilterNav.js
// module id = 704
// module chunks = 209 210 211 212